/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
'use strict';

require('./console-error-suppression');
var client = require('../shared/client');
if (client) {
  // support older browsers (mainly IE11)
  require('@babel/polyfill');
}
var account = require('./account'),
  jsonPayload = require('./json-payload'),
  React = require('react'),
  ReactDOMClient = require('react-dom/client'),
  urls = require('../shared/urls');
require('../shared/analytics');

/*
 * Initializes the React component for the overall page content. This is invoked by every top level React component,
 * which kicks off the client side rendering and brings the component to life on page load. Because the content is
 * rendered on the server beforehand, this re-rendering becomes a no-op except that the components are mounted and
 * initialized (refs, event handlers, etc).
 */
exports.init = function (main) {
  initHeader();
  var props = jsonPayload.get('props');
  ReactDOMClient.hydrateRoot(document.getElementById('react-root'), React.createElement(main, props));
  initFocus();
  initUsabilla();
};
function initFocus() {
  // for accessible tab switching that involves page reloads, a ?focus_main param is added to the url which triggers
  // the initial focus of the next page to be on the #main-content
  if (urls.param(location.href, 'focus_main')) {
    // consume the transient url param
    urls.removeUrlParam('focus_main');
    window.addEventListener('load', function () {
      var main = document.getElementById('main-content');
      if (main) {
        // ensure the element is focusable
        if (!main.hasAttribute('tabindex')) {
          main.tabIndex = -1;
        }
        // prevent unnecessary scroll down
        main.focus({
          preventScroll: true
        });
      }
    });
  }
}
function initHeader() {
  // make account data available globally via account module
  header.whenAccountReady(function (data) {
    return account.set(data.account);
  });
  document.addEventListener('acctChanged', function (evt) {
    return account.set(evt.detail.accountData.account);
  });
}
function initUsabilla() {
  // Initialize Usabilla feedback for all the DevOps pages
  if (!window.isChinaLandingEnabled && window.Bluemix && window.Bluemix.initUsabilla) {
    window.Bluemix.initUsabilla();
  }
}